import React from "react";
import { UiRoundedLogo } from "../UiRoundedLogo";
import { RightArrowIcon } from "../../../styles/img/svg/RightArrowIcon";
import { BlueRightArrowIcon } from "../../../styles/img/svg/BlueRightArrowIcon";

export const UiPayAgainCard = (props) => {
  const logoLetter = props?.logoText || props?.title?.charAt(0) || "";

  return (
    <div className="df-pay-again-card" onClick={props?.handleOnclick}>
      <div className="df-pay-again-card__header">
        <div className="df-pay-again-card__logo">
          {props?.logo ? (
            <UiRoundedLogo logo={props?.logo} />
          ) : (
            <div className="df-text-logo-card df-pay-again-card__text-logo">
              {logoLetter}
            </div>
          )}
        </div>
        <BlueRightArrowIcon className="df-pay-again-card__arrow" />
      </div>

      <p className="df-pay-again-card__description">{props?.description}</p>
      <h4 className="df-pay-again-card__title">{props?.title}</h4>
    </div>
  );
};
